import React from 'react';
import { Truck, Lock, RotateCcw, Headphones } from 'lucide-react';

const VALUES = [
{ icon: Truck, title: 'LIVRAISON RAPIDE', desc: 'En 48/72h chez vous', color: 'text-cs-blue' },
{ icon: Lock, title: 'PAIEMENT SÉCURISÉ', desc: 'Transactions 100% sécurisées', color: 'text-cs-blue' },
{ icon: RotateCcw, title: 'SATISFAIT OU REMBOURSÉ', desc: '14 jours pour changer d\'avis', color: 'text-cs-blue' },
{ icon: Headphones, title: 'SERVICE CLIENT', desc: 'Réponse sous 24h', color: 'text-cs-blue' }];


export default function CSValueBar() {
  return null;














}